/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { useParams } from 'react-router-dom';
import Dashboard, { DashboardSection, DashboardSectionTitle } from '@g17eco/molecules/dashboard';
import { QueryWrapper } from '@g17eco/molecules/query/QueryWrapper';
import { useCreateInitiativeAppIntegrationMutation, useGetInitiativeAppIntegrationQuery } from '@api/initiative-app-integrations';
import { ProviderView } from '@features/integrations/IntegrationView';
import { CreateSetupFn } from '@g17eco/types/app-integration';
import { CTAdminBreadcrumbs } from '../../components/breadcrumbs/CTAdminBreadcrumbs';
import { ROUTES } from '@constants/routes';
import { generateUrl } from '@routes/util';

export const AppIntegrationViewRoute = () => {

  const { code, initiativeId } = useParams<{ code: string, initiativeId: string }>()

  const query = useGetInitiativeAppIntegrationQuery({ initiativeId, code, }, { skip: !code });

  const [createMutation] = useCreateInitiativeAppIntegrationMutation()

  const onCreate: CreateSetupFn = (data) => {
    createMutation({
      code,
      initiativeId,
      generatedAnswers: data.generatedAnswers,
    })
  }

  return (
    <Dashboard>
      <div className='pl-2 pb-4'>
        <CTAdminBreadcrumbs
          initiativeId={initiativeId}
          breadcrumbs={[
            { label: 'Connections', url: generateUrl(ROUTES.APP_INTEGRATIONS, { initiativeId }) },
            { label: 'Set up' },
          ]}
        />
      </div>
      <DashboardSectionTitle title={'Connection set up'} />
      <DashboardSection>
        <QueryWrapper query={query} onSuccess={(data) => <ProviderView onCreate={onCreate} {...data} />} />
      </DashboardSection>
    </Dashboard>
  );
}
